import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Copy } from "lucide-react";
import { toast } from "sonner";

const Row = ({ label, value, mono = true, testId }) => {
  if (!value) return null;
  const copy = () => {
    navigator.clipboard.writeText(value);
    toast.success(`${label} copied`);
  };
  return (
    <div className="flex items-start justify-between gap-4 py-2 border-b border-slate-100 last:border-0">
      <span className="text-xs uppercase tracking-[0.15em] font-semibold text-slate-500 whitespace-nowrap pt-1">
        {label}
      </span>
      <div className="flex items-center gap-2 min-w-0">
        <span
          className={`text-sm text-slate-900 truncate ${mono ? "font-mono" : ""}`}
          data-testid={testId}
          title={value}
        >
          {value}
        </span>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          onClick={copy}
          className="h-7 w-7 text-slate-400 hover:text-slate-900"
          aria-label={`Copy ${label}`}
        >
          <Copy className="w-3.5 h-3.5" />
        </Button>
      </div>
    </div>
  );
};

export const BankDetailsCard = ({ businessInfo, firm, className = "" }) => {
  // If a specific firm is passed use it; otherwise fall back to businessInfo's default shape
  const source = firm || businessInfo;
  if (!source?.bank?.account_number) return null;
  const { bank, payment_note } = source;
  const heading = firm?.name
    ? `Bank details — ${firm.name}`
    : "Bank transfer details";
  return (
    <Card className={`border-slate-200 shadow-none rounded-md ${className}`} data-testid={`bank-details-card${firm?.key ? `-${firm.key}` : ""}`}>
      <div className="p-6">
        <p className="label-tag mb-1">How to pay</p>
        <h3 className="font-display text-lg font-medium text-slate-900 mb-4">
          {heading}
        </h3>
        <div>
          <Row label="Account Name" value={bank.account_name} mono={false} testId="bank-account-name" />
          <Row label="Bank" value={bank.bank_name} mono={false} testId="bank-name" />
          <Row label="Account No." value={bank.account_number} testId="bank-account-number" />
          <Row label="IFSC" value={bank.ifsc} testId="bank-ifsc" />
          <Row label="Branch" value={bank.branch} mono={false} testId="bank-branch" />
          <Row label="UPI" value={bank.upi} testId="bank-upi" />
        </div>
        {payment_note && (
          <p className="mt-4 text-xs text-slate-500 leading-relaxed border-t border-slate-100 pt-3">
            {payment_note}
          </p>
        )}
      </div>
    </Card>
  );
};
